import React from "react";
import * as ROUTES from "../../../constants/routes";
import { PromotionIcon } from "./icons";
import { NavLink, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { addShops } from "../../../reducers/shops";

import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import SettingsIcon from "@material-ui/icons/Settings";
import MobileOffIcon from "@material-ui/icons/MobileOff";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Notifications from "@material-ui/icons/Notifications";
import AlarmIcon from "@material-ui/icons/Alarm";
import CommentIcon from "@material-ui/icons/Comment";
import PaymentIcon from "@material-ui/icons/Payment";
import AccessTime from "@material-ui/icons/AccessTime";
import DepartureBoardIcon from "@material-ui/icons/DepartureBoard";
import List from "@material-ui/core/List";
import Drawer from "@material-ui/core/Drawer";
import Loading from "../../../components/Loading";
import AssignmentIcon from "@material-ui/icons/Assignment";
import NotesIcon from "@material-ui/icons/Notes";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import FolderIcon from "@material-ui/icons/Folder";
import RemoveShoppingCartIcon from "@material-ui/icons/RemoveShoppingCart";

// import IconButton from '@material-ui/core/IconButton';
// import Divider from '@material-ui/core/Divider';
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
// import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import ModalAlert from "../../../components/ModalComponent";

import useStyles from "./styles";

const Navigation = (props) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const navT = (key) => t(`defaultScreen.navigation.${key}`);
	const {
		open,
		width,
		isMenu,
		isPush,
		isReviews,
		isBlackList,
		isCategoryPickup,
		isPromotion,
		isValidPayCard,
		validPromocodesUrl,
		handleClose,
		handleClickSubmit,
		handlePushClick,
		handleMenuClick,
		handleReviewsClick,
		handlePromotionClick,
		handleSettingsClick,
		handleProductsClick,
		handleBlackListCheck,
	} = props;

	const isNewAdmin = props.adminPermission?.newAdmin;

	const history = useHistory();

	const changeCity = (key) => {
		console.log("change");
		const cityId = Number(key);
		if (!Number.isFinite(cityId)) return;
		localStorage.setItem("chosenCity", JSON.stringify(cityId));
		props.chooseCity(key);
		history.push("/");
	};

	const dispatch = useDispatch();

	const changeBrand = (item, key) => {
		const brandKey = Number(key);
		if (!Number.isFinite(brandKey)) return;
		history.push("/");
		localStorage.setItem("chosenBrand", JSON.stringify(brandKey));
		localStorage.setItem("currentBrand", JSON.stringify(item));
		props.chooseBrand(item.id);
		let data = {
			shops: props.listCity,
			appSettings:
				props.listCity[Number(localStorage.getItem("chosenCity"))].brands[
					brandKey
				].appSettings,
			category:
				props.listCity[Number(localStorage.getItem("chosenCity"))].brands[
					brandKey
				].category,
			hiddenCategories:
				props.listCity[Number(localStorage.getItem("chosenCity"))].brands[
					brandKey
				].category.hiddenCategories,
			hiddenProducts:
				props.listCity[Number(localStorage.getItem("chosenCity"))].brands[
					brandKey
				].category.hiddenProducts,
			mainSettings: props.mainSettings,
		};

		// console.log('update shops', data);
		addShops(dispatch, data);
	};

	return (
		<Drawer
			className={classes.drawer}
			variant={
				width !== "lg" && width !== "md" && width !== "xl"
					? "temporary"
					: "persistent"
			}
			anchor="left"
			open={
				width !== "lg" && width !== "md" && width !== "xl" ? props.open : true
			}
			onClose={props.handleDrawerClose}
			classes={{
				paper: classes.drawerPaper,
			}}
		>
			<List className={classes.listWrapper}>
				<ModalAlert
					title={navT("leaveTitle")}
					description={navT("leaveDescription")}
					handleProductsClick
					isReviews
					isPush
					// open={open}
					handleClose={handleClose}
					handleClickSubmit={handleClickSubmit}
				/>

				<Collapse
					className={classes.collapse}
					in={props.openCategory === "menu"}
					timeout="auto"
					unmountOnExit
				>
					<List component="div" className={classes.nestedLink}>
						<NavLink
							to={`/page/test`}
							className={classes.link}
							activeClassName={classes.active}
						>
							<ListItem button className={classes.nested}>
								<ListItemIcon className={classes.iconMenu}>
									{" "}
									<AddShoppingCartIcon />{" "}
								</ListItemIcon>
								<ListItemText primary={navT("products")} />
							</ListItem>
						</NavLink>
						<NavLink
							to={ROUTES.CATEGORIES}
							className={classes.link}
							activeClassName={classes.active}
						>
							<ListItem button className={classes.nested}>
								<ListItemIcon className={classes.iconMenu}>
									{" "}
									<NotesIcon />{" "}
								</ListItemIcon>
								<ListItemText primary={navT("categories")} />
							</ListItem>
						</NavLink>
					</List>
				</Collapse>

				{props.adminPermission && props.adminPermission.pushControl && (
					<div
						onClick={handlePushClick}
						className={classes.link}
						style={{
							background: isPush ? "rgba(50, 109, 255, .1)" : "inherit",
						}}
					>
						<ListItem button>
							<ListItemIcon className={classes.iconMenu}>
								<Notifications
									style={{
										color: isPush ? "#326dff" : "inherit",
										fill: isPush ? "#326dff" : "",
									}}
								/>
							</ListItemIcon>
							<ListItemText
								style={{ color: isPush ? "#326dff" : "inherit" }}
								primary={navT("push")}
							/>
						</ListItem>
					</div>
				)}

				{props.adminPermission && props.adminPermission.promotion && (
					<div
						onClick={handlePromotionClick}
						className={classes.link}
						style={{
							background: isPromotion ? "rgba(50, 109, 255, .1)" : "inherit",
						}}
					>
						<ListItem button>
							<ListItemIcon className={classes.iconMenu}>
								<PromotionIcon
									style={{ fill: isPromotion ? "#326dff" : "inherit" }}
								/>
							</ListItemIcon>
							<ListItemText
								style={{ color: isPromotion ? "#326dff" : "inherit" }}
								primary={navT("promotion")}
							/>
						</ListItem>
					</div>
				)}

				<ListItem
					className={classes.settingsListItem}
					button
					onClick={() => handleSettingsClick()}
				>
					<ListItemIcon className={classes.iconMenu}>
						<SettingsIcon />
					</ListItemIcon>
					<ListItemText
						className={classes.listText}
						primary={navT("settings")}
					/>
					{props.openCategory === "settings" ? <ExpandLess /> : <ExpandMore />}
				</ListItem>

				{isNewAdmin ? (
					<>
						<Collapse
							className={classes.collapse}
							in={props.openCategory === "settings"}
							timeout="auto"
							unmountOnExit
						>
							{props.loadCity ? (
								<div className={classes.load}>
									<Loading color="#326dff" size={24} />
								</div>
							) : (
								<List component="div">
									{props.listCity.map((cityItem) => {
										const brandIds = cityItem?.brands?.map((item) => item.id);
										return (
											<div key={cityItem.key}>
												<ListItem
													key={cityItem.key}
													button
													onClick={() => changeCity(cityItem.key)}
													className={classes.nested}
													style={{
														color:
															props.city === cityItem.key ? "#326dff" : "#000",
													}}
												>
													<ListItemText
														primary={cityItem.name.uk || cityItem.name}
													/>
													{props.city === cityItem.key ? (
														<ExpandLess />
													) : (
														<ExpandMore />
													)}
												</ListItem>
												{/* <Collapse className={classes.collapse} in={(props.city === cityItem.key) ? true : false} timeout="auto" unmountOnExit> */}
												<Collapse
													className={classes.collapse}
													in={
														props.city === cityItem.key ||
														brandIds.includes(props.brand)
															? true
															: false
													}
													timeout="auto"
													unmountOnExit
												>
													{cityItem?.brands?.map((item, index) => {
														return (
															<div key={item.id}>
																<ListItem
																	key={item.id}
																	button
																	onClick={() => changeBrand(item, index)}
																	className={classes.nested}
																	style={{
																		color:
																			props.brand === item.id
																				? "#326dff"
																				: "#000",
																	}}
																>
																	<ListItemText
																		primary={item.name.uk || item.name}
																		style={{ marginLeft: 10 }}
																	/>

																	{props.brand === item.id ? (
																		<ExpandLess />
																	) : (
																		<ExpandMore />
																	)}
																</ListItem>
																<Collapse
																	className={classes.collapse}
																	in={props.brand === item.id ? true : false}
																	timeout="auto"
																	unmountOnExit
																>
																	<List
																		component="div"
																		className={classes.nestedLink}
																	>
																		{props.adminPermission &&
																			props.adminPermission.menu && (
																				<div
																					onClick={handleMenuClick}
																					className={classes.link}
																					style={{
																						background: isMenu
																							? "rgba(50, 109, 255, .1)"
																							: "inherit",
																					}}
																				>
																					<ListItem button>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<AssignmentIcon
																								className={classes.icon}
																								style={{
																									color: isMenu
																										? "#326dff"
																										: "inherit",
																									fill: isMenu ? "#326dff" : "",
																								}}
																							/>
																						</ListItemIcon>
																						<ListItemText
																							style={{
																								color: isMenu
																									? "#326dff"
																									: "inherit",
																							}}
																							primary={navT("stopList")}
																						/>
																					</ListItem>
																				</div>
																			)}

																		{props.adminPermission &&
																			props.adminPermission.blackList && (
																				<NavLink
																					// onClick={handleReviewsClick}
																					to={`/page/blacklist/${item.id}`}
																					className={classes.link}
																					style={{
																						background: isReviews
																							? "rgba(50, 109, 255, .1)"
																							: "inherit",
																					}}
																				>
																					<ListItem button>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<AssignmentIcon
																								className={classes.icon}
																								style={{
																									color: isBlackList
																										? "#326dff"
																										: "inherit",
																									fill: isBlackList
																										? "#326dff"
																										: "",
																								}}
																							/>
																						</ListItemIcon>
																						<ListItemText
																							style={{
																								color: isBlackList
																									? "#326dff"
																									: "inherit",
																							}}
																							primary={navT("blacklist")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}

																		{props.adminPermission &&
																			props.adminPermission
																				.categoryForPickUp && (
																				<NavLink
																					// onClick={handleReviewsClick}
																					to={`/page/categories-pickup/${item.id}`}
																					className={classes.link}
																					style={{
																						background: isCategoryPickup
																							? "rgba(50, 109, 255, .1)"
																							: "inherit",
																					}}
																				>
																					<ListItem button>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<AssignmentIcon
																								className={classes.icon}
																								style={{
																									color: isCategoryPickup
																										? "#326dff"
																										: "inherit",
																									fill: isCategoryPickup
																										? "#326dff"
																										: "",
																								}}
																							/>
																						</ListItemIcon>
																						<ListItemText
																							style={{
																								color: isBlackList
																									? "#326dff"
																									: "inherit",
																							}}
																							primary={navT("pickupCategories")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}

																		{props.adminPermission &&
																			(props.adminPermission
																				? props.adminPermission
																						.productReviews ||
																					props.adminPermission.appReviews ||
																					props.adminPermission.orderReviews !==
																						undefined
																					? props.adminPermission.orderReviews
																					: true
																				: true) && (
																				<NavLink
																					// onClick={handleReviewsClick}
																					to={`/page/reviews/${item.id}`}
																					className={classes.link}
																					style={{
																						background: isReviews
																							? "rgba(50, 109, 255, .1)"
																							: "inherit",
																					}}
																				>
																					<ListItem button>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<CommentIcon
																								style={{
																									color: isReviews
																										? "#326dff"
																										: "inherit",
																									fill: isReviews
																										? "#326dff"
																										: "",
																								}}
																							/>
																						</ListItemIcon>
																						<ListItemText
																							style={{
																								color: isReviews
																									? "#326dff"
																									: "inherit",
																							}}
																							primary={navT("reviews")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}
																		{props.adminPermission &&
																			!!props.adminPermission.delivery && (
																				<NavLink
																					to={`/page/delivery/${item.key}`}
																					className={classes.link}
																					activeClassName={classes.active}
																				>
																					<ListItem
																						button
																						className={classes.nested}
																					>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<DepartureBoardIcon />
																						</ListItemIcon>
																						<ListItemText
																							primary={navT("deliveryTerms")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}
																		{props.adminPermission &&
																			props.adminPermission.workingHours && (
																				<NavLink
																					to={`/page/worktime/${item.key}`}
																					className={classes.link}
																					activeClassName={classes.active}
																				>
																					<ListItem
																						button
																						className={classes.nested}
																					>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<AccessTime />
																						</ListItemIcon>
																						<ListItemText
																							primary={navT("workingHours")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}
																		{props.adminPermission &&
																			props.adminPermission.pickupControl && (
																				<NavLink
																					to={`/page/pickupControl/${item.id}`}
																					className={classes.link}
																					activeClassName={classes.active}
																				>
																					<ListItem
																						button
																						className={classes.nested}
																					>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<RemoveShoppingCartIcon />
																						</ListItemIcon>
																						<ListItemText
																							primary={navT("disablePickup")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}

																		{props.adminPermission &&
																			props.adminPermission.activeZone && (
																				<NavLink
																					to={`/page/deliveryZonesControl/${item.id}`}
																					className={classes.link}
																					activeClassName={classes.active}
																				>
																					<ListItem
																						button
																						className={classes.nested}
																					>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<DepartureBoardIcon />
																						</ListItemIcon>
																						<ListItemText
																							primary={navT("deliveryZones")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}

																		{props.adminPermission &&
																			props.adminPermission.disableApp && (
																				<NavLink
																					to={`/page/disableapp/${item.id}`}
																					className={classes.link}
																					activeClassName={classes.active}
																				>
																					<ListItem
																						button
																						className={classes.nested}
																					>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<MobileOffIcon />
																						</ListItemIcon>
																						<ListItemText
																							primary={navT("disableOrders")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}

																		{props.adminPermission &&
																			props.adminPermission.openAppAlert && (
																				<NavLink
																					to={`/page/disablealert/${item.id}`}
																					className={classes.link}
																					activeClassName={classes.active}
																				>
																					<ListItem
																						button
																						className={classes.nested}
																					>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<MobileOffIcon />
																						</ListItemIcon>
																						<ListItemText
																							primary={navT("loginMessage")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}
																		{props.adminPermission &&
																			props.adminPermission?.iikoMenu && (
																				<NavLink
																					to={`/page/menu-sort/${item.id}`}
																					className={classes.link}
																					activeClassName={classes.active}
																				>
																					<ListItem
																						button
																						className={classes.nested}
																					>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<AccessTime />
																						</ListItemIcon>
																						<ListItemText
																							primary={navT("stopListSorting")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}
																		{props.adminPermission &&
																			props.adminPermission
																				.controlDeliveryInterval && (
																				<NavLink
																					to={`/page/load-control/${item.id}`}
																					className={classes.link}
																					activeClassName={classes.active}
																				>
																					<ListItem button>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<AlarmIcon />
																						</ListItemIcon>
																						<ListItemText
																							primary={navT("loadControl")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}
																		{props.adminPermission &&
																			props.adminPermission.productsTags && (
																				<NavLink
																					to={`/page/labels/${item.id}`}
																					className={classes.link}
																					activeClassName={classes.active}
																				>
																					<ListItem button>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<CommentIcon
																								style={{
																									color: isReviews
																										? "#326dff"
																										: "inherit",
																									fill: isReviews
																										? "#326dff"
																										: "",
																								}}
																							/>
																						</ListItemIcon>
																						<ListItemText
																							style={{
																								color: isReviews
																									? "#326dff"
																									: "inherit",
																							}}
																							primary={navT("labels")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}
																		{isValidPayCard && (
																			<NavLink
																				to={`/page/paycard/${item.id}`}
																				className={classes.link}
																				activeClassName={classes.active}
																			>
																				<ListItem
																					button
																					className={classes.nested}
																				>
																					<ListItemIcon
																						className={classes.iconMenu}
																					>
																						<PaymentIcon />
																					</ListItemIcon>
																					<ListItemText
																						primary={navT("cardPayment")}
																					/>
																				</ListItem>
																			</NavLink>
																		)}
																		{props.adminPermission &&
																			(props.adminPermission.saleFirstOrder ||
																				props.adminPermission.promoCodes ||
																				props.adminPermission
																					.bannerControl) && (
																				<NavLink
																					to={validPromocodesUrl(item)}
																					className={classes.link}
																					activeClassName={classes.active}
																				>
																					<ListItem
																						button
																						className={classes.nested}
																					>
																						<ListItemIcon
																							className={classes.iconMenu}
																						>
																							<LoyaltyIcon />
																						</ListItemIcon>
																						<ListItemText
																							primary={navT("loyaltySystem")}
																						/>
																					</ListItem>
																				</NavLink>
																			)}
																	</List>
																</Collapse>
															</div>
														);
													})}
												</Collapse>
											</div>
										);
									})}
								</List>
							)}
						</Collapse>
					</>
				) : (
					<>
						<Collapse
							className={classes.collapse}
							in={props.openCategory === "settings"}
							timeout="auto"
							unmountOnExit
						>
							{props.loadCity ? (
								<div className={classes.load}>
									<Loading color="#326dff" size={24} />
								</div>
							) : (
								<List component="div">
									{props.listCity.map((item) => {
										return (
											<div key={item.key}>
												<ListItem
													key={item.key}
													button
													onClick={() => props.chooseCity(item.key)}
													className={classes.nested}
													style={{
														color: props.city === item.key ? "#326dff" : "#000",
													}}
												>
													<ListItemText primary={item.name.uk} />
													{props.city === item.key ? (
														<ExpandLess />
													) : (
														<ExpandMore />
													)}
												</ListItem>

												<Collapse
													className={classes.collapse}
													in={props.city === item.key ? true : false}
													timeout="auto"
													unmountOnExit
												>
													<List component="div" className={classes.nestedLink}>
														{props.adminPermission &&
															props.adminPermission.menu && (
																<div
																	onClick={handleMenuClick}
																	className={classes.link}
																	style={{
																		background: isMenu
																			? "rgba(50, 109, 255, .1)"
																			: "inherit",
																	}}
																>
																	<ListItem button>
																		<ListItemIcon className={classes.iconMenu}>
																			<AssignmentIcon
																				className={classes.icon}
																				style={{
																					color: isMenu ? "#326dff" : "inherit",
																					fill: isMenu ? "#326dff" : "",
																				}}
																			/>
																		</ListItemIcon>
																		<ListItemText
																			style={{
																				color: isMenu ? "#326dff" : "inherit",
																			}}
																			primary={navT("stopList")}
																		/>
																	</ListItem>
																</div>
															)}

														{props.adminPermission &&
															props.adminPermission.categoryForPickUp && (
																<NavLink
																	// onClick={handleReviewsClick}
																	to={`/page/categories-pickup/${item.key}`}
																	className={classes.link}
																	style={{
																		background: isCategoryPickup
																			? "rgba(50, 109, 255, .1)"
																			: "inherit",
																	}}
																>
																	<ListItem button>
																		<ListItemIcon className={classes.iconMenu}>
																			<AssignmentIcon
																				className={classes.icon}
																				style={{
																					color: isCategoryPickup
																						? "#326dff"
																						: "inherit",
																					fill: isCategoryPickup
																						? "#326dff"
																						: "",
																				}}
																			/>
																		</ListItemIcon>
																		<ListItemText
																			style={{
																				color: isBlackList
																					? "#326dff"
																					: "inherit",
																			}}
																			primary={navT("pickupCategories")}
																		/>
																	</ListItem>
																</NavLink>
															)}

														{props.adminPermission &&
															(props.adminPermission
																? props.adminPermission.productReviews ||
																	props.adminPermission.appReviews ||
																	props.adminPermission.orderReviews !==
																		undefined
																	? props.adminPermission.orderReviews
																	: true
																: true) && (
																<NavLink
																	// onClick={handleReviewsClick}
																	to={`/page/reviews/${item.key}`}
																	className={classes.link}
																	style={{
																		background: isReviews
																			? "rgba(50, 109, 255, .1)"
																			: "inherit",
																	}}
																>
																	<ListItem button>
																		<ListItemIcon className={classes.iconMenu}>
																			<CommentIcon
																				style={{
																					color: isReviews
																						? "#326dff"
																						: "inherit",
																					fill: isReviews ? "#326dff" : "",
																				}}
																			/>
																		</ListItemIcon>
																		<ListItemText
																			style={{
																				color: isReviews
																					? "#326dff"
																					: "inherit",
																			}}
																			primary={navT("reviews")}
																		/>
																	</ListItem>
																</NavLink>
															)}

														{props.adminPermission &&
															props.adminPermission.blackList && (
																<NavLink
																	// onClick={handleReviewsClick}
																	to={`/page/blacklist/${item.id}`}
																	className={classes.link}
																	style={{
																		background: isReviews
																			? "rgba(50, 109, 255, .1)"
																			: "inherit",
																	}}
																>
																	<ListItem button>
																		<ListItemIcon className={classes.iconMenu}>
																			<AssignmentIcon
																				className={classes.icon}
																				style={{
																					color: isBlackList
																						? "#326dff"
																						: "inherit",
																					fill: isBlackList ? "#326dff" : "",
																				}}
																			/>
																		</ListItemIcon>
																		<ListItemText
																			style={{
																				color: isBlackList
																					? "#326dff"
																					: "inherit",
																			}}
																			primary={navT("blacklist")}
																		/>
																	</ListItem>
																</NavLink>
															)}

														{props.adminPermission &&
															!!props.adminPermission.delivery && (
																<NavLink
																	to={`/page/delivery/${item.key}`}
																	className={classes.link}
																	activeClassName={classes.active}
																>
																	<ListItem button className={classes.nested}>
																		<ListItemIcon className={classes.iconMenu}>
																			<DepartureBoardIcon />
																		</ListItemIcon>
																		<ListItemText
																			primary={navT("deliveryTerms")}
																		/>
																	</ListItem>
																</NavLink>
															)}
														{props.adminPermission &&
															props.adminPermission.workingHours && (
																<NavLink
																	to={`/page/worktime/${item.key}`}
																	className={classes.link}
																	activeClassName={classes.active}
																>
																	<ListItem button className={classes.nested}>
																		<ListItemIcon className={classes.iconMenu}>
																			<AccessTime />
																		</ListItemIcon>
																		<ListItemText
																			primary={navT("workingHours")}
																		/>
																	</ListItem>
																</NavLink>
															)}
														{props.adminPermission &&
															props.adminPermission.pickupControl && (
																<NavLink
																	to={`/page/pickupControl/${item.key}`}
																	className={classes.link}
																	activeClassName={classes.active}
																>
																	<ListItem button className={classes.nested}>
																		<ListItemIcon className={classes.iconMenu}>
																			<RemoveShoppingCartIcon />
																		</ListItemIcon>
																		<ListItemText
																			primary={navT("disablePickup")}
																		/>
																	</ListItem>
																</NavLink>
															)}
														{props.adminPermission &&
															props.adminPermission.disableApp && (
																<NavLink
																	to={`/page/disableapp/${item.key}`}
																	className={classes.link}
																	activeClassName={classes.active}
																>
																	<ListItem button className={classes.nested}>
																		<ListItemIcon className={classes.iconMenu}>
																			<MobileOffIcon />
																		</ListItemIcon>
																		<ListItemText
																			primary={navT("disableOrders")}
																		/>
																	</ListItem>
																</NavLink>
															)}

														{props.adminPermission &&
															props.adminPermission.openAppAlert && (
																<NavLink
																	to={`/page/disablealert/${item.key}`}
																	className={classes.link}
																	activeClassName={classes.active}
																>
																	<ListItem button className={classes.nested}>
																		<ListItemIcon className={classes.iconMenu}>
																			<MobileOffIcon />
																		</ListItemIcon>
																		<ListItemText
																			primary={navT("loginMessage")}
																		/>
																	</ListItem>
																</NavLink>
															)}
														{props.adminPermission &&
															props.adminPermission?.iikoMenu && (
																<NavLink
																	to={`/page/menu-sort/${item.key}`}
																	className={classes.link}
																	activeClassName={classes.active}
																>
																	<ListItem button className={classes.nested}>
																		<ListItemIcon className={classes.iconMenu}>
																			<AccessTime />
																		</ListItemIcon>
																		<ListItemText
																			primary={navT("stopListSorting")}
																		/>
																	</ListItem>
																</NavLink>
															)}
														{props.adminPermission &&
															props.adminPermission.controlDeliveryInterval && (
																<NavLink
																	to={`/page/load-control/${item.key}`}
																	className={classes.link}
																	activeClassName={classes.active}
																>
																	<ListItem button>
																		<ListItemIcon className={classes.iconMenu}>
																			<AlarmIcon />
																		</ListItemIcon>
																		<ListItemText
																			primary={navT("loadControl")}
																		/>
																	</ListItem>
																</NavLink>
															)}
														{isValidPayCard && (
															<NavLink
																to={`/page/paycard/${item.key}`}
																className={classes.link}
																activeClassName={classes.active}
															>
																<ListItem button className={classes.nested}>
																	<ListItemIcon className={classes.iconMenu}>
																		<PaymentIcon />
																	</ListItemIcon>
																	<ListItemText primary={navT("cardPayment")} />
																</ListItem>
															</NavLink>
														)}
														{props.adminPermission &&
															props.adminPermission.productsTags && (
																<NavLink
																	to={`/page/labels/${item.id}`}
																	className={classes.link}
																	activeClassName={classes.active}
																>
																	<ListItem button>
																		<ListItemIcon className={classes.iconMenu}>
																			<CommentIcon
																				style={{
																					color: isReviews
																						? "#326dff"
																						: "inherit",
																					fill: isReviews ? "#326dff" : "",
																				}}
																			/>
																		</ListItemIcon>
																		<ListItemText
																			style={{
																				color: isReviews
																					? "#326dff"
																					: "inherit",
																			}}
																			primary={navT("labels")}
																		/>
																	</ListItem>
																</NavLink>
															)}
														{props.adminPermission &&
															(props.adminPermission.saleFirstOrder ||
																props.adminPermission.promoCodes ||
																props.adminPermission.bannerControl ||
																props.adminPermission.isPromotionsBanners) && (
																<NavLink
																	to={validPromocodesUrl(item)}
																	className={classes.link}
																	activeClassName={classes.active}
																>
																	<ListItem button className={classes.nested}>
																		<ListItemIcon className={classes.iconMenu}>
																			<LoyaltyIcon />
																		</ListItemIcon>
																		<ListItemText
																			primary={navT("loyaltySystem")}
																		/>
																	</ListItem>
																</NavLink>
															)}
													</List>
												</Collapse>
											</div>
										);
									})}
								</List>
							)}
						</Collapse>
					</>
				)}

				{props.adminPermission && props.adminPermission.ourAdmin && (
					<ListItem button onClick={() => handleProductsClick()}>
						<ListItemIcon className={classes.iconMenu}>
							<FolderIcon />
						</ListItemIcon>
						<ListItemText
							className={classes.listText}
							primary={navT("menuFilling")}
						/>
						{props.openProducts === "products" ? (
							<ExpandLess />
						) : (
							<ExpandMore />
						)}
					</ListItem>
				)}

				{props.adminPermission && props.adminPermission.ourAdmin && (
					<Collapse
						className={classes.collapse}
						in={props.openProducts === "products"}
						timeout="auto"
						unmountOnExit
					>
						{props.preloader ? (
							<div className={classes.loader}>
								<Loading />
							</div>
						) : (
							<List component="div">
								<NavLink
									exact
									to={ROUTES.PRODUCTS}
									className={classes.link}
									activeClassName={classes.active}
								>
									<ListItem button className={classes.nested}>
										<ListItemText primary={navT("categories")} />
									</ListItem>
								</NavLink>
								<NavLink
									exact
									to={ROUTES.ADD_PRODUCTS}
									className={classes.link}
									activeClassName={classes.active}
								>
									<ListItem button className={classes.nested}>
										<ListItemText primary={navT("addProduct")} />
									</ListItem>
								</NavLink>
								<NavLink
									exact
									to={ROUTES.EDIT_PRODUCTS}
									className={classes.link}
									activeClassName={classes.active}
								>
									<ListItem button className={classes.nested}>
										<ListItemText primary={navT("editProduct")} />
									</ListItem>
								</NavLink>
								{props.adminPermission.productsOrder && (
									<NavLink
										exact
										to={ROUTES.SORT_MODE_CATEGORIES}
										className={classes.link}
										activeClassName={classes.active}
									>
										<ListItem button className={classes.nested}>
											<ListItemText primary={navT("sortMode")} />
										</ListItem>
									</NavLink>
								)}
							</List>
						)}
					</Collapse>
				)}
			</List>
		</Drawer>
	);
};

export default Navigation;
